import WsBaseRequest from "./ws-request.js";

export default class SyncTime {

    constructor(ws) {
        this._d = 0;
        this._respDelay = Number.MAX_VALUE;
        this._ws = ws;
    }

    async syncTime() {

        if (this._ws == null || !this._ws.isConnected) {
            return false;
        }

        this._respDelay = Number.MAX_VALUE;

        return await this._syncTime() && await this._syncTime();
    }

    async _syncTime(){
        let st = await this._makeSyncTimeCall();

        if (!st.r){
            return false;
        }

        if (this._respDelay < st.respDelay){
            return true
        }

        this._respDelay = st.respDelay;
        this._d = st.delta;
        return true;
    }

    async _makeSyncTimeCall() {
        let reqT = Date.now();
        let resp = await this.asyncSendMessage(new WsBaseRequest("time", {}));
        let respT = Date.now();

        if (!resp.re || resp.d == null || !resp.d.t) {
            return {r: false}
        }

        let respDelay = respT - reqT;
        let delta = resp.d.t - respDelay / 2 - reqT ;

        return {r: true, delta, respDelay}
    }

    async asyncSendMessage(request, timeout) {
        return new Promise((resolve, reject) => {
            this._ws.sendMessage(request, function (resp) {
                resolve(resp)
            }, timeout)
        })
    }

    get time() {
        return Date.now() + this._d
    }
}

